export default __webpack_public_path__ + "static/color-analysis-hair-colors-551fcab088387c82392b51209db7d414.jpg";